/*
 * PingClient.js
 * PingClient Frontend JS for dein-ip-check.de
 *
 * @version 3.0
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

/**
 * Library für PingCheck-Script
 */
declare global {
    interface Array<T> {
        last(): any;
        objAvg(prop: string): number;
    }

    //Interface für das PingCheckResult Objekt
    interface PingCheckResult {
        [key:string]: number,
        jitter: number,
        ping: number,
        zeitstempel: number
    }

    // Websocket Response Objekt
    interface PingCheckWebsocketResponse {
        command: string,
        message: string,
        protocol: string,
        status: string,
        clientip: string,
    }
}

/**
 * Prototype: Letztes Element eines Arrays zurpckgeben
 */
Array.prototype.last = Array.prototype.last || function ():any {
    return this.slice(-1)[0];
};

/**
 * Prototyp: Durchschnitt aus einem Array erstellen, welches von einem Objekt mit der Methode
 * "value" berechnen
 */
Array.prototype.objAvg = Array.prototype.objAvg || function (prop: string): number {
    try {
        let sum:number = 0;
        let result:number = 0;

        if(this.length > 0) {
            // noinspection JSUnusedLocalSymbols
            this.forEach(function(v:PingCheckResult, i:number, a:object[]) {
                if (!v.hasOwnProperty(prop) ) {
                    throw "Object inside array has no '" + prop + "' object";
                }
                sum = sum + v[prop];
            });

            result = sum / this.length;
        }

        return result;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export {};
